import { render, staticRenderFns } from "./BecomeACreatorValues.vue?vue&type=template&id=f500d4aa"
import script from "./BecomeACreatorValues.vue?vue&type=script&lang=js"
export * from "./BecomeACreatorValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports